"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundCreateTransport = exports.RefundTransport = exports.RefundLineItemInput = exports.RefundLineItemTransport = exports.RefundLineItemStorage = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RefundLineItemStorage = typebox_1.Type.Object({
    originalLineItemID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Number(),
    totalPrice: typebox_1.Type.Number(),
    taxable: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Number(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.RefundLineItemTransport = typebox_1.Type.Object({
    originalLineItemID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Number(),
    unitPriceDollars: typebox_1.Type.Number(),
    totalPrice: typebox_1.Type.Number(),
    totalPriceDollars: typebox_1.Type.Number(),
    taxable: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Number(),
    taxDollars: typebox_1.Type.Number(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.RefundLineItemInput = typebox_1.Type.Object({
    originalLineItemID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitPriceDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    totalPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    totalPriceDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxable: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.RefundTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    date: typebox_1.Type.String(),
    amount: typebox_1.Type.Number(),
    amountDollars: typebox_1.Type.Number(),
    paymentMethod: typebox_1.Type.String(),
    refundedByUserID: typebox_1.Type.String(),
    refundIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    stripeRefundID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    lineItems: typebox_1.Type.Array(exports.RefundLineItemTransport),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    })),
});
exports.RefundCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RefundTransport, ['id', 'date', 'amount', 'amountDollars', 'refundedByUserID', 'lineItems', 'metadata']),
    typebox_1.Type.Object({
        date: typebox_1.Type.Optional(typebox_1.Type.String()),
        amount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        amountDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
        lineItems: typebox_1.Type.Optional(typebox_1.Type.Array(exports.RefundLineItemInput)),
    }),
]);
//# sourceMappingURL=refund-transport.js.map